import axios from 'axios'

const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://api.scamwall.io'

const HEADERS = { 'Content-Type': 'application/json' }


const axiosInstance = axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
})


axiosInstance.interceptors.request.use(
    async (req) => {
        // Add configurations here
        req.headers["Authorization"] = localStorage.getItem('jwt')
        return req;
    },
    (err) => {
        return Promise.reject(err);
    }
);

//See if backend takes HTTP only cookie jwt. If expired, use the refresh token
axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
        const originalConfig = err.config;

        if (originalConfig.url !== "/user/refresh" && err.response && err.response.status !== 404 && err.response.status !== 500) {
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;
                try {
                    //Different end point then 

                    const rs = await axiosInstance.post(`${BASE_URL}/user/refresh`, { refreshToken: localStorage.getItem('refreshToken') }, { withCredentials: false, headers: HEADERS });

                    if (rs.status === 403) {
                        window.location.replace('/#/login?refresh=true')
                    }
                    const { jwt } = rs.data;
                    localStorage.setItem('jwt', jwt)
                    return axiosInstance(originalConfig);

                } catch (_error) {
                    localStorage.removeItem('jwt')
                    localStorage.removeItem('refreshToken')
                    window.location.replace('/#/login?refresh=true')
                    return Promise.reject(_error);
                }
            }
        }
        return Promise.reject(err);
    }
);




const API = {

    async login(email, password) {
        return axiosInstance.post(`${BASE_URL}/user/login`, { email, password }, { headers: HEADERS })
            .then(res => {
                if (!res.data.isError && res.data?.user?.role === 'ADMIN') {
                    localStorage.setItem('jwt', res.data.jwt)
                    localStorage.setItem('refreshToken', res.data.refreshToken)
                }
                return res.data
            })
            .catch(err => err)
    },
    async signup(user) {
        return axiosInstance.post(`${BASE_URL}/user/signup`, { user }, { headers: HEADERS })
            .then(res => {
                if (!res.data.err) {
                    localStorage.setItem('jwt', res.data.jwt)
                    localStorage.setItem('refreshToken', res.data.refreshToken)
                }
                return res.data
            })
            .catch(err => err)
    },


    async logout() {
        localStorage.removeItem('jwt')
        const refreshToken = localStorage.getItem('refreshToken')
        localStorage.removeItem('refreshToken')
        window.location.reload()
        return axiosInstance.post(`${BASE_URL}/user/logout`, { refreshToken }, { headers: HEADERS, withCredentials: false })
            .then(response => response.data)
            .catch(err => err)
    },

    async checkValidReset(token) {
        return axiosInstance.post(`${BASE_URL}/user/check-valid-reset`, { token }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async sendForgot(email) {
        return axiosInstance.post(`${BASE_URL}/user/forgot`, { email }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async resetPassword(token, password) {
        return axiosInstance.post(`${BASE_URL}/user/reset-password`, { token, password }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getSubAccounts() {
        return axiosInstance.get(`${BASE_URL}/user/accounts`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getFileNames() {
        return axiosInstance.get(`${BASE_URL}/filename/all`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getUser() {
        return axiosInstance.get(`${BASE_URL}/user/`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async getStats() {
        return axiosInstance.get(`${BASE_URL}/log/admin`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async createSuggestion(msg) {
        return axiosInstance.post(`${BASE_URL}/log/suggestion`, { msg }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async changeName(fName, lName) {
        return axiosInstance.put(`${BASE_URL}/user`, { fName, lName }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async addNotifyNumber(userId, number) {
        return axiosInstance.put(`${BASE_URL}/user/add-notify-num`, { userId, number }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async removeNotifyNumber(userId, number) {
        return axiosInstance.put(`${BASE_URL}/user/remove-notify-num`, { userId, number }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },


    async grantAccess(params) {
        return axiosInstance.post(`${BASE_URL}/user/grant-access`, params, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },


    async checkIfEmailExists(email) {
        return axiosInstance.post(`${BASE_URL}/user/check-exists`, { email }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async signupCode(phoneNumber) {
        return axiosInstance.post(`${BASE_URL}/user/signup-code`, { phoneNumber }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async confirmCode(code) {
        return axiosInstance.post(`${BASE_URL}/user/confirm-code`, { code }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async setupPaymentMethod() {
        return axiosInstance.post(`${BASE_URL}/payment/payment-method`, {}, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async checkCouponCode(code) {
        return axiosInstance.post(`${BASE_URL}/payment/check-coupon`, { code }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async getSubscription() {
        return axiosInstance.get(`${BASE_URL}/payment/subscription`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async updateSubscription(quantity) {
        return axiosInstance.put(`${BASE_URL}/payment/subscription`, { quantity }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getPaymentMethods() {
        return axiosInstance.get(`${BASE_URL}/payment/payment-method`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async addSubscription(quantity) {
        return axiosInstance.put(`${BASE_URL}/payment/add-subscription`, { quantity }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async cancelSubscription(reason, comment) {
        return axiosInstance.post(`${BASE_URL}/payment/cancel`, { reason, comment }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async stopCancellation() {
        return axiosInstance.post(`${BASE_URL}/payment/stop-cancel`, {}, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async updatePaymentMethod(methodId) {
        return axiosInstance.put(`${BASE_URL}/payment/payment-method`, { methodId }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async subscribe(quantity, isLifeTime, couponId, noCoupon) {
        return axiosInstance.post(`${BASE_URL}/payment/subscribe`, { quantity, isLifeTime, couponId, noCoupon }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async flipDevice(userId, deviceId) {
        return axiosInstance.put(`${BASE_URL}/user/flip-device`, { userId, deviceId }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async flipOnboard() {
        return axiosInstance.put(`${BASE_URL}/user/flip-onboard`, {}, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },
    async addUser(user) {
        return axiosInstance.post(`${BASE_URL}/user/add-user`, { user }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getBlockedEmails() {
        return axiosInstance.get(`${BASE_URL}/block-email`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async updateBlockedEmail(id, status) {
        return axiosInstance.put(`${BASE_URL}/block-email/`, { id, status }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getPhishingUrls() {
        return axiosInstance.get(`${BASE_URL}/unlock-code/phishing-links`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },


    async resendInvite(userId) {
        return axiosInstance.post(`${BASE_URL}/user/resend-invite`, { userId }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getAffiliate() {
        return axiosInstance.get(`${BASE_URL}/affiliate`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async setupBank() {
        return axiosInstance.get(`${BASE_URL}/payment/connect-signup`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getStripeLink() {
        return axiosInstance.get(`${BASE_URL}/payment/connect-link`, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async approveUrl(url) {
        return axiosInstance.post(`${BASE_URL}/user/approve-url`, {url}, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

    async getScreenShot(id) {
        return axios.post(`https://ihvz3upz37ufff7bcuedn3745m0ctjfx.lambda-url.us-east-1.on.aws/`, { id }, { headers: HEADERS })
            .then(res => res.data)
            .catch(err => err)
    },

}

export default API
